import { ValidationComponent } from "./../validation/validation.component";
import { UserserviceService } from "src/app/Services/userservice.service";
import { Component, HostListener, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { DataService } from "../service/data.service";
import { ApiService } from "../service/apiservice.service";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import {
  OrganizationService,
  AcceptInviteRequest,
  orgInviteEmployeeStorageKey,
} from "src/app/Services/organization.service";

import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  FormControlName,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { environment } from "src/environments/environment";
import { Endpoint } from "src/app/shared/endpoints";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
})
export class RegistrationComponent implements OnInit {
  showNotificationCount: boolean;
  notificationCount: number;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  isCapsLockPressed: boolean;
  name: any;
  maxdesclenght = 500;
  currentdesclenght = 0;
  registerForm: UntypedFormGroup;
  personModel: any = [];
  UserName = "";
  FullName = "";
  recaptchaReactive: string;
  EmailAddress = "";
  Password = "";
  ConfirmPassword = "";
  storageService: any;
  userNameTaken: boolean;
  userEmailTaken: boolean;
  emailTaken: boolean;
  cannotContainSpace: any;
  showDotMsg: boolean;
  fullStop: any;
  isEmailValid: boolean;

  registrationModel: {
    UserName: string;
    FirstName: string;
    EmailAddress: string;
    Password: string;
    ConfirmPassword: string;
    UserType: string;
    Country: string;
  };
  isMobileView: boolean;
  noResultReturned: boolean;
  signupError: string = "";

  /** Invite-linked registration (from /org/join returnUrl). */
  isInviteRegistration = false;
  inviteId = "";
  inviteOrganizationId = "";
  employeeId = "";
  referralCode = "";
  division = "";
  department = "";
  location = "";
  shift = "";
  divisionLabel = "Division";
  departmentLabel = "Department";
  locationLabel = "Location";
  shiftLabel = "Shift";
  divisionOptions: string[] = [];
  departmentOptions: string[] = [];
  locationOptions: string[] = [];
  shiftOptions: string[] = [];

  @Output() closeModal = new EventEmitter<void>();

  constructor(
    private data: DataService,
    public route: Router,
    private apiService: ApiService,
    private http: HttpClient,
    public formBuilder: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userserviceService: UserserviceService,
    public authModalService: AuthModalService,
    private organizationService: OrganizationService
  ) {}

  /** Basic fields only — do not block on username/email-taken warnings. */
  get canSignUp(): boolean {
    if (this.noResultReturned) {
      return false;
    }
    const form = this.registerForm;
    if (!form) {
      return false;
    }
    return (
      form.get("UserName")?.valid &&
      form.get("FullName")?.valid &&
      form.get("EmailAddress")?.valid &&
      form.get("Password")?.valid &&
      form.get("ConfirmPassword")?.valid &&
      form.get("checkbox")?.value === true
    );
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      FullName: new UntypedFormControl("", Validators.required),
      checkbox: new UntypedFormControl(false, Validators.requiredTrue),
      UserName: new UntypedFormControl("", [
        this.validateUserName("UserName"),
        Validators.required,
      ]),

      EmailAddress: new UntypedFormControl("", [
        Validators.required,
        this.validateEmail("EmailAddress"),
        Validators.email,
      ]),
      // Keep signup light: required + min length only (no complexity blockers)
      Password: new UntypedFormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
      ConfirmPassword: new UntypedFormControl("", [
        Validators.required,
        Validators.minLength(6),
        this.equalto("Password"),
      ]),
    });

    // Keep signup blank — never reuse login/profile values
    this.UserName = "";
    this.FullName = "";
    this.EmailAddress = "";
    this.Password = "";
    this.ConfirmPassword = "";
    this.registerForm.reset({
      FullName: "",
      checkbox: false,
      UserName: "",
      EmailAddress: "",
      Password: "",
      ConfirmPassword: "",
    });

    this.getProfileUser();
    this.detectInviteRegistration();

    const width = window.innerWidth || document.body.clientWidth;

    if (width <= 1024) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }

  private detectInviteRegistration(): void {
    let returnUrl =
      this.activatedRoute.snapshot.queryParamMap.get("returnUrl") || "";
    if (!returnUrl) {
      try {
        returnUrl = localStorage.getItem("returnUrl") || "";
      } catch {
        returnUrl = "";
      }
    }
    if (!returnUrl) {
      return;
    }

    try {
      const parsed = new URL(returnUrl, window.location.origin);
      if (!parsed.pathname.includes("/org/join")) {
        return;
      }
      this.inviteId = parsed.searchParams.get("inviteId") || "";
      this.inviteOrganizationId =
        parsed.searchParams.get("organizationId") || "";
      if (!this.inviteId || !this.inviteOrganizationId) {
        return;
      }
      this.isInviteRegistration = true;
      this.loadInviteRegistrationOptions();
    } catch {
      /* ignore malformed returnUrl */
    }
  }

  private loadInviteRegistrationOptions(): void {
    this.organizationService
      .getInviteRegistrationOptions(
        this.inviteOrganizationId,
        this.inviteId
      )
      .subscribe({
        next: (opts) => {
          this.divisionLabel = opts?.divisionLabel || "Division";
          this.departmentLabel = opts?.departmentLabel || "Department";
          this.locationLabel = opts?.locationLabel || "Location";
          this.shiftLabel = opts?.shiftLabel || "Shift";
          this.divisionOptions = opts?.divisions || [];
          this.departmentOptions = opts?.departments || [];
          this.locationOptions = opts?.locations || [];
          this.shiftOptions = opts?.shifts || [];
        },
        error: () => {
          /* fall back to free-text inputs */
        },
      });
  }

  private stashInviteEmployeeDetails(): void {
    if (!this.isInviteRegistration || !this.inviteId) {
      return;
    }
    const payload: AcceptInviteRequest = {
      employeeId: (this.employeeId || "").trim() || undefined,
      referralCode: (this.referralCode || "").trim() || undefined,
      division: (this.division || "").trim() || undefined,
      department: (this.department || "").trim() || undefined,
      location: (this.location || "").trim() || undefined,
      shift: (this.shift || "").trim() || undefined,
    };
    try {
      sessionStorage.setItem(
        orgInviteEmployeeStorageKey(this.inviteId),
        JSON.stringify(payload)
      );
    } catch {
      /* ignore quota / private mode */
    }
  }

  validateEmail(field_name: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const input = control.value;

      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var result = re.test(input);

      const isValid = (this.isEmailValid = result);
      if (!isValid) {
        return { equalTo: { isValid } };
      } else {
        return null;
      }
    };
  }

  equalto(field_name: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const input = control.value;

      const isValid = control.root.value[field_name] === input;
      if (!isValid) {
        return { equalTo: { isValid } };
      } else {
        return null;
      }
    };
  }

  resolved(captchaResponse: string) {}

  IsUserEmailTaken() {
    if (this.EmailAddress != "" && this.EmailAddress != null) {
      this.noResultReturned = true;
      //
      const loginModel = {
        UserEmail: this.EmailAddress,
      };
      this.userserviceService
        .checkUserWithEmailAddressExists(loginModel)
        .subscribe((data) => {
          if (data == true) {
            this.userEmailTaken = true;
          }
          if (data == false) {
            this.userEmailTaken = false;
          }
          this.noResultReturned = false;

          //
        });
    }
  }

  createFlow() {
    this.router.navigate(["/create-guide"]);
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.resize();
  }

  resize() {}

  onResize(event) {
    this.resize();

    const width = window.innerWidth || document.body.clientWidth;

    if (width <= 1024) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
      });
    }
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }

  userNameChanged() {
    const loginModel = {
      EmailAddress: this.EmailAddress,
      UserName: this.UserName,
    };
    this.noResultReturned = true;
    //

    this.userserviceService.userNameChanged(loginModel).subscribe((data) => {
      if (data.isTaken === "Taken") {
        this.userNameTaken = true;
      }
      if (data.isTaken === "NotTaken") {
        this.userNameTaken = false;
      }

      // tslint:disable-next-line: align
      this.noResultReturned = false;

      //
    });
  }

  SignUp() {
    if (!this.canSignUp) {
      return;
    }

    this.signupError = "";
    this.noResultReturned = true;

    // Country is optional — never block registration if geo lookup fails
    this.http.get<any>("https://ipapi.co/json/").subscribe({
      next: (locationData) => {
        this.submitRegistration(locationData?.country_name || "");
      },
      error: () => {
        this.submitRegistration("");
      },
    });
  }

  private submitRegistration(country: string) {
    this.registrationModel = {
      UserName: (this.UserName || "").trim().toLowerCase(),
      FirstName: (this.FullName || "").trim(),
      EmailAddress: (this.EmailAddress || "").trim(),
      Password: this.Password,
      ConfirmPassword: this.ConfirmPassword,
      UserType: "User",
      Country: country,
    };

    this.userserviceService
      .saveUser(Endpoint.registerUser, this.registrationModel)
      .subscribe({
        next: () => {
          this.stashInviteEmployeeDetails();
          this.noResultReturned = false;
          localStorage.setItem(
            "activateaccountemailaddress",
            this.EmailAddress
          );
          this.authModalService.openModal("activateaccount");
        },
        error: (err) => {
          this.noResultReturned = false;
          const body = err?.error;
          this.signupError =
            (typeof body === "string" && body) ||
            body?.message ||
            "Sign up failed. Please try again.";
        },
      });
  }

  eventHandler(event) {
    this.UserName = this.UserName.toLowerCase();
    if (event.code == "CapsLock") {
      this.isCapsLockPressed = true;
    } else {
      this.isCapsLockPressed = false;
    }
  }

  validateUserName(field_name): ValidatorFn {
    if (!this.isCapsLockPressed) {
      return (control: AbstractControl): { [key: string]: any } => {
        this.UserName = control.value;
        var count = 0;
        let regExp = /^[a-zA-Z0-9-_.]+$/;
        let isValid = regExp.test(this.UserName);
        let alphabets = "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z";
        let upperCasealphabets =
          "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z";

        if (isValid) {
          if (
            this.UserName.length == 1 &&
            !alphabets.toLowerCase().includes(this.UserName.toLowerCase())
          ) {
            isValid = false;
          }
        }

        if (isValid) {
          if (this.UserName != "" && this.UserName != undefined) {
            count = (this.UserName.match(/\./g) || []).length;
            if (count > 1) {
              isValid = false;
            }
          }
        }

        if (isValid) {
          if (this.UserName != "" && this.UserName != undefined) {
            var lastLetter = this.UserName.charAt(this.UserName.length - 1);
            if (lastLetter == ".") {
              isValid = false;
            }
          }

          this.UserName = this.UserName.toLowerCase();
        }

        if (isValid) {
          var numbers = /^[0-9]+$/;
          if (this.UserName.match(numbers)) {
            isValid = false;
          }
        }

        if (!isValid) return { validateUserName: { isValid } };
        else return null;
      };
    } else {
      this.isCapsLockPressed = false;
    }
  }
}
